// Match a visitor's compliance gaps to a real enforcement case.

const SYM = { GBP: "\u00a3", EUR: "\u20ac", USD: "$" };

// assumptions.sector strings -> dataset sector enums.
const SECTOR_MAP = {
  "SaaS / Technology": "technology",
  "AI / Machine learning": "technology",
  "E-commerce / Retail": "retail_ecommerce",
  "Health / Life sciences": "healthcare",
  "Finance / Fintech": "finance",
  "Marketing / AdTech": "adtech_media",
  "Education": "other",
  "Other": "other",
};

export function mapSector(sector) {
  return SECTOR_MAP[sector] || "other";
}

const COV_TAG = { eu_rep: "eu_representative", uk_rep: "uk_representative", swiss_rep: "eu_representative", eu_ai_rep: "ai_act" };

// Ordered scenario tags for the visitor: representative gaps first (top gap
// wins the match), then broader obligations we spotted.
export function scenarioTags(coverage, findings) {
  const tags = [];
  const push = (t) => { if (t && !tags.includes(t)) tags.push(t); };
  (coverage || []).filter((c) => c.status === "required").forEach((c) => push(COV_TAG[c.id]));
  (coverage || []).filter((c) => c.status === "recommended").forEach((c) => push(COV_TAG[c.id]));
  (findings || []).forEach((f) => {
    const s = `${f.id || ""} ${f.title || ""} ${f.framework || ""} ${f.why || ""}`.toLowerCase();
    if (f.id === "special-category" || s.includes("special category") || s.includes("article 9")) push("special_category");
    if (s.includes("cookie") || s.includes("pecr") || s.includes("eprivacy") || s.includes("marketing")) push("eprivacy_cookies");
    if (s.includes("transfer") || s.includes("scc") || s.includes("chapter v") || s.includes("international")) push("international_transfers");
    if (s.includes("breach") || s.includes("security") || s.includes("article 32")) push("data_breach");
    if (s.includes("transparency") || s.includes("notice") || s.includes("article 13") || s.includes("article 14")) push("transparency");
    if (s.includes("rights") || s.includes("dsar") || s.includes("subject request") || s.includes("access request")) push("dsar");
    if (s.includes("ai act") || s.includes("artificial intelligence")) push("ai_act");
  });
  return tags;
}

export function pickCase(cases, tags, sector) {
  if (!Array.isArray(cases) || !cases.length || !tags || !tags.length) return null;
  let best = null;
  let bestScore = 0;
  cases.forEach((c) => {
    let score = 0;
    tags.forEach((t, i) => { if ((c.scenario_tags || []).includes(t)) score += tags.length - i; });
    if (score === 0) return;
    if (sector && c.sector === sector) score += 0.5;
    const better = !best || score > bestScore ||
      (score === bestScore && (c.year > best.year || (c.year === best.year && c.amount_value > best.amount_value)));
    if (better) { best = c; bestScore = score; }
  });
  return best;
}

export function formatAmount(c) {
  if (!c) return "";
  if (c.amount_display) return c.amount_display;
  const v = c.amount_value || 0;
  if (v > 0) {
    const sym = SYM[c.amount_currency] || "";
    if (v >= 1e6) return `${sym}${(v / 1e6).toFixed(v % 1e6 ? 1 : 0)}M`;
    if (v >= 1e3) return `${sym}${Math.round(v / 1e3)}K`;
    return `${sym}${v}`;
  }
  return "Corrective order, no fine";
}
